module.exports = __webpack_public_path__ + "media/images/icon-login-email@3x-f480cdb5ca09f9728087e233fc60fdb8.png";